import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';

import { formatFileName } from 'utils/func';
import { REGISTER_RESULT_FILE_TYPE } from 'constant';
import DownloadOrViewPdf from 'components/DownloadOrViewPdf';
import CustomFileUpload from '../UploadFile';

export default function UploadAppendixes({ disabled, appendixeArray, handleDownloadFile }) {
  // #region Data
  const { t } = useTranslation();

  // #endregion Data
  return (
    <>
      <h6 className="font-bold my-2">{t('formLayout.Appendix')}</h6>
      <div className="relative pl-4">
        {!disabled && (
          <CustomFileUpload
            name="expenditureAndAppendix"
            maxFileSize={20000000}
            acceptOnly="pdfOnly"
          />
        )}
      </div>

      <div className="file-appendix-table">
        <table>
          <tbody>
            {appendixeArray?.map((summaryReportAppendixe) => (
              <tr>
                <td>
                  <DownloadOrViewPdf
                    opts={{
                      filename: summaryReportAppendixe?.filename,
                      type: REGISTER_RESULT_FILE_TYPE.APPENDIXES,
                    }}
                    fileName={formatFileName(summaryReportAppendixe?.filename)}
                    handleDownloadOrView={handleDownloadFile}
                    showIcon
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

UploadAppendixes.propTypes = {
  disabled: PropTypes.bool,
  errors: PropTypes.shape({}).isRequired,
  control: PropTypes.shape({}).isRequired,
  handleDownloadFile: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
  appendixeArray: PropTypes.array,
};

UploadAppendixes.defaultProps = {
  disabled: false,
  handleDownloadFile: () => null,
  appendixeArray: [],
};
